import React from "react";
import PropTypes from "prop-types";
import { Button } from "react-bootstrap";
import classNames from "classnames";

import HeaderCopy from "./HeaderCopy";
import { useButtonProps } from "../hooks/useButtonProps";

import PlayStoreDownload from "../images/mobile-store-button/play-store.svg";
import AppleStoreDownload from "../images/mobile-store-button/apple-store.svg";

const downloadButtons = {
    "android-download": <PlayStoreDownload />,
    "iphone-download": <AppleStoreDownload />,
};

const HeaderButton = ({ button }) => {
    const buttonProps = useButtonProps(button);

    if (["android-download", "iphone-download"].includes(button.variant)) {
        button.label = downloadButtons[button.variant];
        buttonProps.className = "p-0 rounded-4 mx-3";
        buttonProps.variant = "link";
    }

    return (
        <Button variant={button.variant} size="lg" {...buttonProps}>
            {button.label}
        </Button>
    );
};

const HeaderContent = ({ header }) => {
    const { title, buttons, copy, className } = header;

    return (
        <div
            className={classNames(
                "header-content text-center text-md-start mt-4 mt-md-0",
                className
            )}
        >
            {title && <HeaderCopy title={title} lead={copy} />}
            {buttons?.length && (
                <div className="d-flex justify-content-center justify-content-md-start flex-wrap my-3">
                    {buttons?.map(button => (
                        <HeaderButton key={button.url} button={button} />
                    ))}
                </div>
            )}
        </div>
    );
};

HeaderContent.propTypes = {
    header: PropTypes.shape({
        title: PropTypes.shape({ raw: PropTypes.string }),
        lead: PropTypes.shape({ raw: PropTypes.string }),
        buttons: PropTypes.arrayOf(
            PropTypes.shape({
                id: PropTypes.string.isRequired,
                label: PropTypes.string.isRequired,
                color: PropTypes.string.isRequired,
                url: PropTypes.string.isRequired,
                outlineStyle: PropTypes.bool,
                openNewTab: PropTypes.bool,
                disabled: PropTypes.bool,
            })
        ),
    }),
};

export default HeaderContent;
